import { WorkorderStatus } from '../types/serviceRequest'

export const getInitials = (name: string = '') => {
    const names = name.split(' ')
    const initials = names.map((n) => n.charAt(0).toUpperCase())

    if (initials.length > 1) {
        return `${initials[0]}${initials[initials.length - 1]}`
    } else {
        return initials[0]
    }
}

export const getNumFromURLSegment = (urlSegment: string) => {
    // takes in a partial url that starts at a number, returns the number and the rest of the url

    for (let i = 0; i < urlSegment.length; i++) {
        if (isNaN(Number(urlSegment.charAt(i)))) {
            //our current character is not part of the number
            // everything before it is the number
            return {
                urlSegment: urlSegment.substring(i),
                number: Number(urlSegment.substring(0, i)),
            }
        }
    }
    /// the entire string is the number
    return {
        urlSegment: '',
        number: Number(urlSegment),
    }
}

export const getPluralEnding = (num: number) => {
    if (num > 1) {
        return 's'
    }
    return ''
}

export const getUiStatus = (status: WorkorderStatus) => {
    switch (status) {
        case WorkorderStatus.APPROVED:
            return 'Approved'
        case WorkorderStatus.ASSIGNED:
            return 'Assigned'
        case WorkorderStatus.COMPLETE:
            return 'Complete'
        case WorkorderStatus.INVOICED:
            return 'Invoiced'
        case WorkorderStatus.IN_PROGRESS:
            return 'In Progress'
        case WorkorderStatus.GO_BACK:
            return 'Go Back'
        case WorkorderStatus.PAUSE:
            return 'Paused'
        case WorkorderStatus.PRE_APPROVED:
            return 'Pre-Approved'
    }
}

export const getLongFormDate = (date: string | undefined) => {
    if (!date) {
        return ''
    }
    return new Date(date).toLocaleDateString('en-US', {
        month: 'long',
        day: 'numeric',
        year: 'numeric',
    })
}

export const getShortFormDate = (date: string | undefined) => {
    if (!date) {
        return ''
    }
    return new Date(date).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    })
}

export const getCurrency = (amount: string | number | undefined | null) => {
    if (amount === undefined || amount === null) {
        return '$0.00'
    }
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
    }).format(Number(amount))
}

export const getUiCamelCase = (status: string): string => {
    return status
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ')
}

export const formatUsPhoneInput = (value: string): string => {
    const digits = value.replace(/\D/g, '')
    const national =
        digits.length === 11 && digits.startsWith('1')
            ? digits.slice(1, 11)
            : digits.slice(0, 10)
    if (national.length < 4) {
        return national
    }
    if (national.length < 7) {
        return `(${national.slice(0, 3)}) ${national.slice(3)}`
    }
    return `(${national.slice(0, 3)}) ${national.slice(3, 6)}-${national.slice(6)}`
}

export const getBillingMonth = (month: string) => {
    const date = new Date(month)
    // Set to end of month to avoid timezone issues
    date.setDate(date.getDate() + 1)
    return date.toLocaleDateString('en-US', {
        month: 'long',
        year: 'numeric',
    })
}
